import React from 'react'

function Navbar() {
  return (
    <nav className='navbar'>
        <div className="container">
            <h3 className='logo'>Where in the world ?</h3>
        </div>
    </nav>
  )
}

export default Navbar